import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import PageHeader from "../../core/common/commonComponents/PageHeader";
import { exportToCSV, exportToExcel, exportToPDF } from "../../core/common/GlobalFunctions/exportTableData";
import StatusFilterHeader from "../../core/common/commonComponents/StatusFilterHeader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import DeleteModal1 from "../../core/modals/deleteModal1";
import { message } from "antd";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";
import PfPolicyModal from "./modals/PfPolicyModal";
import { deletePfPolicy, fetchAllPfPolicies } from "../../core/data/redux/payroll/Accounting/providentFund/pfpolicies/pfPolicyActions";

const ProvidentFundPolicies = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [selectedStatus, setSelectedStatus] = useState('active');
    const [selectedSort, setSelectedSort] = useState<any>("");
    const [tableKey, setTableKey] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
    const [modalType, setModalType] = useState<'edit' | 'create' | ''>('');
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const { records } = useSelector((state: any) => state.providentFund.pfPolicy);

    const showModal = (type: 'edit' | 'create') => {
        setModalType(type);
        setIsModalVisible(true);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
        setModalType('');
    };

    useEffect(() => {
        if (!records.length) {
            dispatch(fetchAllPfPolicies())
        }
    }, [dispatch, records.length])
    
const filtereddata = useMemo(() => {
  const filters = selectedStatus && selectedStatus !== "All"
      ? { status: selectedStatus }
      : {};
  return filterData(records, filters, "createdAt", "createdAt", selectedSort);
}, [records, selectedStatus, selectedSort]);

const exportData =  filtereddata.map((item: any) => ({
    // pfPolicyId: item.pfPolicyId || "N/A",
    policyName: item.policyName || "N/A",
    employeeContributionPercent: item.employeeContributionPercent ?? 0,
    employerContributionPercent: item.employerContributionPercent ?? 0,
    maxWageLimit: item.maxWageLimit ?? 0,
    isVoluntary: item.isVoluntary,
    status: item.status || "Inactive",
    // createdBy: item.createdBy || "N/A",
    // modifiedBy: item.modifiedBy || "N/A",
    createdAt: item.createdAt ? new Date(item.createdAt).toLocaleDateString("en-IN") : "N/A",
    modifiedAt: item.modifiedAt ? new Date(item.modifiedAt).toLocaleDateString("en-IN") : "N/A",
  }));

    useEffect(() => {
        setTableKey(prevKey => prevKey + 1);
    }, [selectedStatus, selectedSort, records]);

    const handleDeletepfPolicy = async (id: number) => {
        try {
            const result = await dispatch(deletePfPolicy(id));
            if (result.meta.requestStatus === 'fulfilled') {
                message.success('Policy deleted successfully');
                setTableKey((prevKey) => prevKey + 1);
                setIsDeleteModalVisible(false);
                await dispatch(fetchAllPfPolicies())
            } else {
                message.error((result.payload as { error: string })?.error);
            }
        } catch (error) {
            message.error('Something went wrong');
        }
    };

    const columns = [
        {
          title: "Policy Name",
          dataIndex: "policyName",
          sorter: (a: any, b: any) => a.policyName.localeCompare(b.policyName),
        },
        {
          title: "Employee Share (%)",
          dataIndex: "employeeContributionPercent",
          sorter: (a: any, b: any) => parseFloat(a.employeeContributionPercent) - parseFloat(b.employeeContributionPercent),
        },
        {
          title: "Employer Share (%)",
          dataIndex: "employerContributionPercent",
          sorter: (a: any, b: any) => parseFloat(a.employerContributionPercent) - parseFloat(b.employerContributionPercent),
        },
        {
          title: "Voluntary",
          dataIndex: "isVoluntary",
          render: (isVoluntary: number) => (
            <span className={`badge ${isVoluntary ? 'badge-success' : 'badge-secondary'}`}>
              {isVoluntary ? "Yes" : "No"}
            </span>
          ),
          filters: [
            { text: 'Yes', value: 1 },
            { text: 'No', value: 0 }
          ],
          onFilter: (value: number, record: any) => record.isVoluntary === value,
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text: string, record: any) => (
                <span className={`badge ${text === 'active' ? 'badge-success' : 'badge-danger'} d-inline-flex align-items-center badge-xs`}>
                    <i className="ti ti-point-filled me-1" />
                    {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

                </span>

            ),
        },
        {
          title: "Action",
          dataIndex: "actions",
          render: (_: any, record: any) => (
            <div className="action-icon d-inline-flex">
              <button className="me-2" onClick={() => { showModal("edit"); setSelectedRowData(record); }} data-bs-toggle="tooltip"
                     data-bs-placement="top"
                       title="Edit">
                <i className="ti ti-edit" />
              </button>
              <button onClick={() => { setSelectedRowData(record); setIsDeleteModalVisible(true); }} data-bs-toggle="tooltip"
                  data-bs-placement="top"
                    title="Delete">
                <i className="ti ti-trash" />
              </button>
            </div>
          ),
        },
      ];
      
    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <PageHeader
                        title="Provident Fund Policy"
                        breadcrumbs={[
                            { label: <i className="ti ti-smart-home" />, path: all_routes.adminDashboard },
                            { label: "Accounting" },
                            { label: "Provident Fund Policy List", isActive: true },
                        ]}
                        // listViewPath={all_routes.clientlist}
                        listViewPath="#"
                        onExportCSV={() => exportToCSV(exportData, 'ProvidentFundPolicyData')}
                        onExportExcel={() => exportToExcel(exportData, 'ProvidentPolicyFundData')}
                        onExportPDF={() => exportToPDF(exportData, 'ProvidentPolicyFundData')}
                        onAdd={() => showModal('create')}
                        addLabel="Add Provident Fund Policy"
                        exportEnabled
                        addButtonEnabled
                        rightExtra={<CollapseHeader />}
                    />
                    {/* /Breadcrumb */}
                    <div className="card">
                        <StatusFilterHeader
                            title="Provident Fund Policy List"
                            selectedStatus={selectedStatus}
                            setSelectedStatus={setSelectedStatus}
                            selectedSort={selectedSort}
                            setSelectedSort={setSelectedSort}
                        />
                        <div className="card-body p-0">
                            <Table key={tableKey} dataSource={filtereddata} columns={columns} Selection={false} />
                        </div>
                    </div>
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                    <p className="mb-0">2024 - 2025© hrmtree.</p>
                    <p>
                        Developed By{" "}
                        <Link to="#" className="text-primary">
                            Leadchain Systems
                        </Link>
                    </p>
                </div>
            </div>
            <PfPolicyModal modalType={modalType} handleCancel={handleCancel} isModalVisible={isModalVisible} selectedRowData={selectedRowData} />
            <DeleteModal1
                isVisible={isDeleteModalVisible}
                onClose={() => setIsDeleteModalVisible(false)}
                onConfirm={() => selectedRowData?.pfPolicyId && handleDeletepfPolicy(selectedRowData.pfPolicyId)}
            />
        </>
    );
};
export default ProvidentFundPolicies;
